import React, { useContext } from 'react';
import classNames from 'classnames';

import Button from '../../../components/buttons/Button';
import Spinner from '../../../components/loaders/Spinner';
import Icon from '../../../components/icons/Icon';

import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';

import {
    getTemplateId,
    getTemplateTitle,
    getTemplateType,
    getTemplateEntryDisplayName,
    getTemplateIsCustom,
} from '../boardTemplatePickerUtil';

import { SimpleTemplate, Template, TemplatesMap } from '../templateTypes';

import './BoardTemplatePickerBodyListingButton.scss';
import './BoardTemplatePickerBodyListingTemplateButton.scss';

type Props = {
    templateEntry: Template | SimpleTemplate;
    templates: TemplatesMap;
    selectedTemplateId: string | null;
    selectTemplate: (templateId: string | null) => void;
    isTopPick?: boolean;
    isCustomTemplate?: boolean;
};

const TemplateStatusTag = ({ templateId }: { templateId: string }) => {
    const { loadingTemplateId, templateFetchErrors } = useContext(boardTemplatePickerContext);

    let Component;

    const errorMessage = templateFetchErrors[templateId];
    if (errorMessage) {
        Component = <Icon name="error-alert-round" />;
    }

    if (loadingTemplateId && loadingTemplateId === templateId) {
        Component = <Spinner show strokeWeightMultiplier={2} />;
    }

    if (!Component) return null;

    return <span className="TemplateStatusTag">{Component}</span>;
};

const BoardTemplatePickerBodyListingTemplateButton = ({
    templateEntry,
    templates,
    selectedTemplateId,
    selectTemplate,

    isTopPick,
    isCustomTemplate,
}: Props) => {
    const templateId = getTemplateId(templateEntry);
    const template = templates[templateId];

    const title = getTemplateEntryDisplayName(templateEntry) || getTemplateTitle(template);
    const type = getTemplateType(template);

    const classes = classNames('TemplatePickerListingButton TemplateButton', type && type.toLowerCase(), {
        selected: selectedTemplateId === templateId,
    });

    return (
        <Button className={classes} onClickFn={() => selectTemplate(templateId)}>
            <span className="title">
                {title}
                <TemplateStatusTag templateId={templateId} />
            </span>

            {isTopPick && !isCustomTemplate && <span className="template-tag">Top pick</span>}
            {isCustomTemplate && <span className="template-tag">Custom</span>}
        </Button>
    );
};

export default BoardTemplatePickerBodyListingTemplateButton;
